import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

const STORAGE_KEY = "licito_cookie_consent_v1";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) {
        // Small delay so the banner slides in after the hero renders
        const t = setTimeout(() => setVisible(true), 800);
        return () => clearTimeout(t);
      }
    } catch (_) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ ts: Date.now() }));
    } catch (_) {}
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="cookie-banner"
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[70] w-[calc(100%-2rem)] max-w-[720px] print:hidden"
        >
          <div className="relative bg-white/95 backdrop-blur border hairline rounded-lg shadow-[0_10px_40px_-10px_rgba(26,58,97,0.25)] p-5 pr-12 md:p-6 md:pr-14">
            <button
              onClick={accept}
              aria-label="Fechar aviso de cookies"
              data-testid="cookie-close"
              className="absolute top-3 right-3 h-8 w-8 rounded-md flex items-center justify-center text-[#1A3A61]/50 hover:text-[#1A3A61] hover:bg-[#F1F5FF] transition-colors"
            >
              <X size={16} strokeWidth={2} />
            </button>
            <div className="flex flex-col md:flex-row md:items-center gap-4 md:gap-6">
              <p className="text-[13.5px] md:text-[14px] leading-[1.6] text-[#1A3A61]/85 flex-1">
                Utilizamos cookies essenciais para manter sua sessão ativa e
                garantir o funcionamento do sistema. Ao continuar, você concorda
                com nossa{" "}
                <Link
                  to="/lgpd"
                  className="underline underline-offset-2 font-medium text-[#1A3A61] hover:text-[#00C2D1]"
                >
                  Política de Privacidade
                </Link>
                .
              </p>
              <button
                onClick={accept}
                data-testid="cookie-accept"
                className="btn-primary text-[13px] md:text-[14px] whitespace-nowrap"
              >
                Aceitar e continuar
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
